import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useHistory } from "react-router-dom";
import io from "socket.io-client";

const ChatContext = createContext();

const ENDPOINT = process.env.REACT_APP_BASE_URL;

const ChatProvider = ({ children }) => {
  const [selectedChat, setSelectedChat] = useState();
  const [user, setUser] = useState();
  const [notification, setNotification] = useState([]);
  const [chats, setChats] = useState();
  const socketRef = useRef(null);

  const history = useHistory();

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const resolvedUser = { token: userInfo?.token, ...userInfo?.data, id: 0 };
    setUser(resolvedUser);

    if (ENDPOINT && !socketRef.current) {
      socketRef.current = io(ENDPOINT, { transports: ["websocket"] });
      const socket = socketRef.current;
      // Rooms are lost on reconnect; re-establish the existing setup contract.
      socket.on("connect", () => socket.emit("setup", resolvedUser));
    }

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return (
    <ChatContext.Provider
      value={{
        selectedChat,
        setSelectedChat,
        user,
        setUser,
        notification,
        setNotification,
        chats,
        setChats,
        socket: socketRef.current,
        socketRef,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export const ChatState = () => useContext(ChatContext);

export default ChatProvider;
